import { render } from "./SpecialCampaign.vue?vue&type=template&id=4f640293"
import script from "./SpecialCampaign.vue?vue&type=script&lang=js"
export * from "./SpecialCampaign.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./SpecialCampaign.vue?vue&type=style&index=0&id=4f640293&lang=scss&module=s"
cssModules["s"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__